import styled from 'vue-styled-components';

import theme from '@/config/theme';

export const LinkForgotPassword = styled('a')`
  color: ${theme.colors.gray6};
  font-size: ${theme.font.sizes.p2};
  margin-right: auto;

  &:hover {
    opacity: .7;
  }
`;

export const LinkSignOn = styled('a')`
  align-items: center;
  color: #722C64;
  display: inline-flex;
  font-size: ${theme.font.sizes.p1};
  font-weight: ${theme.font.bold};
  gap: ${theme.spacings.small};
  justify-content: center;
  line-height: ${theme.font.lineHeights.p1};
  position: relative;
  text-transform: uppercase;

  &:hover {
    color: ${theme.colors.primaryDark};

    :after {
      background-color: ${theme.colors.primaryDark};
      bottom: 5px;
      content: "";
      height: 1px;
      position: absolute;
      width: 100%;
    }
  }
`;
export const Paragraph = styled('span')`
  margin-top: 35px;
`;
export const LinkSignOnLinkWhatsApp = styled('a')`
  align-items: center;
  color: green;
  display: inline-flex;
  font-size: 16px;
  margin-left: 3px;
  font-weight: ${theme.font.bold};
  gap: ${theme.spacings.small};
  justify-content: center;
  line-height: ${theme.font.lineHeights.p1};
  position: relative;
  text-transform: uppercase;

  &:hover {
    color: ${theme.colors.primaryDark};

    :after {
      background-color: ${theme.colors.primaryDark};
      bottom: 5px;
      content: "";
      height: 1px;
      position: absolute;
      width: 100%;
    }
  }
`;
export const LinkSignOnLink = styled('a')`
  align-items: center;
  color: black;
  margin-left: 3px;
  top: 30px;
  display: inline-flex;
  font-size: 10px;
  font-weight: ${theme.font.bold};
  gap: ${theme.spacings.small};
  justify-content: center;
  line-height: ${theme.font.lineHeights.p1};
  position: relative;
  text-transform: uppercase;

  &:hover {
    color: ${theme.colors.primaryDark};

    :after {
      background-color: ${theme.colors.primaryDark};
      bottom: 5px;
      content: "";
      height: 1px;
      position: absolute;
      width: 100%;
    }
  }
`;

export const LoginErrorMessage = styled('p')`
  color: ${theme.colors.supportError};
  font-size: ${theme.font.sizes.p3};
  margin-top: ${theme.spacings.xxxlarge};
  text-align: center;

  &:not(.visible) {
    display: none;
  }
`;

export const TextNotRegistered = styled('p')`
  color: ${theme.colors.gray5};
  font-size: ${theme.font.sizes.p2};
  line-height: ${theme.font.lineHeights.p2};
`;

export const WrapperButton = styled('div')`
  align-items: center;
  display: flex;
  justify-content: flex-end;
  margin-top: ${theme.spacings.xxxlarge};
`;

export const WrapperInput = styled('div')`
  display: flex;
  flex-direction: column;
  gap: ${theme.spacings.xxxlarge};
  margin-top: ${theme.spacings.xxxlarge};
`;

export const WrapperMain = styled('main')`
  align-items: center;
  display: flex;
  flex-direction: column;
  justify-content: center;
  min-height: 100%;
  padding: 30px 0;
`;

export const WrapperSignOn = styled('div')`
  border-top: 1px solid ${theme.colors.gray3};
  margin-top: ${theme.spacings.xxxlarge};
  padding-top: ${theme.spacings.large};
  text-align: center;
`;
